module.exports = __webpack_public_path__ + "static/media/Original Korean Article from - TATHAGATA - message - juk.97ee8ff6.pdf";